import { gql } from '@apollo/client'

export const GET_SUPPLIER_COVERAGE_PREVIEW = gql`
  query GetSupplierCoveragePreview(
    $bookingId: Long!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    supplierCoveragePreview(
      bookingId: $bookingId
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          supplierName
          contactName
          email
          telephoneNumber
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`
